import {connect} from 'react-redux'
import React, {Component} from 'react'
import moment from 'moment'
import request from 'superagent'
import MetronicIndex from '../layout/metronic/index'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter, PortletAlert} from '../component/widget/portlet'
import BootstrapTable from 'react-bootstrap-table-next'
import apis from '../helper/api'
import localdata from '../helper/localdata'
import action from '../helper/action'
import do_action from '../action'
import config from '../helper/config'
import swal from 'sweetalert'
import util from '../helper/util'
import Modal from 'react-responsive-modal'
import ModalProfile from '../component/form/dialog_profile'
import ModalListCommisionBonus from '../component/form/dialog_list_commision_bonus'
import ModalTransferBalance from '../component/form/dialog_transfer_balance'
import ModalDevice from '../component/form/dialog_device'

let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"
let tx_product = ""
const label_btn = {ACTIVE: "Deactive", REGISTERING: "Approve", UNAPPROVED: "Approve", DEACTIVATED: "Activate"}

class MAgentManageAgent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            search_show_more_btn: false,
            downline_show_more_btn: false,
            search_load_more_flag_processing: false,
            downline_load_more_flag_processing: false,
            search_agent_name : "",
            search_agent_status : "",
            search_agent_downline : "",
            search_agent_by_master_id : "",
            data_upline : "",
            data_downline : "",
            data_agent_search : "",
            data_agent_registering : "",
            show_profile : false,
            show_downline: false,
            show_report_agent: false,
            show_transfer_balance: false,
            show_daftar_device: false,
            show_daftar_device_data: "",
            show_transfer_balance_data: [],
            show_user_id : "",
            show_user_url : "",
            show_user_type: "",
            sel_downline: "",
            show_report_agent_data: "",
            propinsi: "", kota: "",
            list_propinsi: [],
            list_kota: []
        }
        this.search_agent = this.search_agent.bind(this)
        this.change_status_agent = this.change_status_agent.bind(this)
        this.on_search_btn_load_more = this.on_search_btn_load_more.bind(this)
        this.on_downline_btn_load_more = this.on_downline_btn_load_more.bind(this)
    }

    componentDidMount() {
        this.props.update_current_page('manage-agent')
        let self = this
        this.get_master_upline()
        this.get_master_downline()
        this.get_agent_registering()
        this.load_propinsi()
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_select_change(e) {
        util.log(e.target.id + ": " + e.target.value)
        let self = this
        if (e.target.id === 'search_status') {
            this.setState({search_agent_status : e.target.value})
        } else if (e.target.id === 'search_downline') {
            this.setState({search_agent_downline : e.target.value})
        } else if (e.target.id === 'propinsi-sel') {
            self.setState({propinsi: e.target.value, kota: ""})
            if (e.target.value.length !== 0) {
                let url = apis.domain + "api/helper/geoname/" + e.target.value + "/city/list"
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status === 200) {
                            const data = JSON.parse(res.text)
                            if (data.status === "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'city_id' : item.city_id, 'city_name' : item.city_name})
                                )
                                self.setState({list_kota: t})
                            }
                        }
                    }
                })
            }
        } else if (e.target.id === 'kota-sel') {
            self.setState({kota: e.target.value})
            if (e.target.value.length !== 0) {
                let url = apis.domain + "api/helper/geoname/" + self.state.propinsi + "/" + e.target.value + "/district/list"
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status == 200) {
                            const data = JSON.parse(res.text)
                            if (data.status == "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'district_id' : item.district_id, 'district_name' : item.district_name})
                                )
                                self.setState({list_kecamatan: t})
                            }
                        }
                    }
                })
            }
        }
    }

    get_master_downline() {
        let body = {
            "session_id" : this.props.session
        }
        let self = this
        request.post(apis.list_downline)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            let show_more = false
                            let next = ''
                            if (payload.results.next_page !== null) {
                                next = payload.results.next_page
                                show_more = true
                            }
                            self.setState({data_downline: {data: payload.results.list, next: next}, downline_show_more_btn: show_more})
                        }
                    }
                }
            })
    }

    get_master_upline() {
        let body = {
            "session_id" : this.props.session
        }
        let self = this
        request.post(apis.list_upline)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            self.setState({data_upline: {data: payload.results.list, next: payload.results.next_page}})
                        }
                    }
                }
            })
    }

    get_agent_registering() {
        let body = {
            "session_id" : this.props.session
        }
        let self = this
        request.post(apis.list_my_agent_registering)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            self.setState({data_agent_registering: {data: payload.results.list, next: payload.results.next_page}})
                        }
                    }
                }
            })
    }

    search_agent() {
        let body = {
            "session_id" : this.props.session
        }
        let self = this
        let url = apis.list_my_agent_all
        let search_key = ''
        if (this.state.search_agent_name.length !== 0){
            search_key = this.state.search_agent_name
        }
        if (this.state.kota.length !== 0) {
            search_key = search_key + ' ' + this.state.kota
        } else if (this.state.propinsi.length !== 0) {
            search_key = search_key + ' ' + this.state.propinsi
        }
        if (search_key.length !== 0) {
            body.search = search_key
            let status = 'all'
            if (this.state.search_agent_status.length !== 0) {
                status = this.state.search_agent_status
            }
            if (this.state.search_agent_downline.length !== 0) {
                url = apis.search_agent_master_downline + this.state.search_agent_downline + "/agent/search/" + status
            } else {
                url = apis.search_my_agent + status
            }
        } else if (this.state.search_agent_downline.length === 0) {
            if (this.state.search_agent_status === 'active') {
                url = apis.list_my_agent_active
            } else if (this.state.search_agent_status === 'suspended') {
                url = apis.list_my_agent_suspended
            } else if (this.state.search_agent_status === 'unapproved') {
                url = apis.list_my_agent_unapproved
            } else if (this.state.search_agent_status === 'deactivated') {
                url = apis.list_my_agent_deactivated
            } else if (this.state.search_agent_status === 'registering') {
                url = apis.list_my_agent_registering
            }
        } else {
            url = apis.list_downline_agent + this.state.search_agent_downline + '/agent/list/'
            if (this.state.search_agent_status === 'active') {
                url = url + 'active'
            } else if (this.state.search_agent_status === 'suspended') {
                url = url + 'suspended'
            } else if (this.state.search_agent_status === 'unapproved') {
                url = url + 'unapproved'
            } else if (this.state.search_agent_status === 'deactivated') {
                url = url + 'deactivated'
            } else if (this.state.search_agent_status === 'registering') {
                url = url + 'registering'
            } else {
                url = url + 'all'
            }
        }
        self.setState({data_agent_search: "", flag_cari_processing: true})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            let next_page = ""
                            let show_more = false
                            if (payload.results.next_page !== null) {
                                next_page = payload.results.next_page
                                show_more = true
                            }
                            self.setState({data_agent_search: {data: payload.results.list, next: next_page}, search_show_more_btn: show_more})
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
                self.setState({flag_cari_processing: false})
            })
    }

    change_status_master_agent(e, index, master_agent_id, to_status, tag) {
        util.log(master_agent_id + " " + to_status, e, e.target.classList)
        let status = ""
        if (to_status.toLowerCase() === 'approve') {
            status = 'active'
        } else if (to_status.toLowerCase() === 'deactive') {
            status = 'deactivated'
        } else if (to_status.toLowerCase() === 'activate') {
            status = 'active'
        } else if (to_status.toLowerCase() === 'suspend') {
            status = 'suspended'
        } else if (to_status.toLowerCase() === 'unapproved') {
            status = 'unapproved'
        }
        if (status.length === 0) {
            return
        }
        let body = {
            "session_id" : this.props.session,
            "status_new" : status
        }
        let self = this
        let url = apis.change_status_master.replace("{master_id}", master_agent_id)
        const target = e.target
        target.disabled = true
        target.classList.add('m-loader', 'm-loader--light', 'm-loader--right')
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                    target.disabled = false
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            target.disabled = false
                            if (self.state.data_downline.data) {
                                util.log("ok")
                                let data_downline = self.state.data_downline
                                let obj = data_downline.data[index]
                                obj.status = status.toUpperCase()
                                self.setState({data_downline: data_downline})
                            }
                        } else {
                            target.disabled = false
                            swal("Ups!", payload.error.message, "warning")
                        }
                    } else {
                        target.disabled = false
                    }
                }
                target.classList.remove('m-loader', 'm-loader--light', 'm-loader--right')
            })
    }

    change_status_agent(e, index, master_id, agent_id, to_status, tag) {
        util.log(master_id + " " + agent_id + " " + to_status, e, e.target.classList)
        let status = ""
        if (to_status.toLowerCase() === 'approve') {
            status = 'active'
        } else if (to_status.toLowerCase() === 'deactive') {
            status = 'deactivated'
        } else if (to_status.toLowerCase() === 'activate') {
            status = 'active'
        } else if (to_status.toLowerCase() === 'suspend') {
            status = 'suspended'
        } else if (to_status.toLowerCase() === 'unapproved') {
            status = 'unapproved'
        }
        if (status.length === 0) {
            return
        }
        let body = {
            "session_id" : this.props.session,
            "status_new" : status
        }
        let self = this

        let url = apis.change_status_agent + agent_id + "/change-status"
        if (master_id.length !== 0 && this.props.profile.masterid !== master_id) {
            url = apis.change_status_agent_of_downline.replace("{master_id}", master_id).replace("{agent_id}", agent_id)
        }
        
        const target = e.target
        target.disabled = true
        target.classList.add('m-loader', 'm-loader--light', 'm-loader--right')
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                    target.disabled = false
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            target.disabled = false
                            if (tag === 'data_agent_registering') {
                                if (self.state.data_agent_registering.data) {
                                    util.log("ok data_agent_registering")
                                    let data_agent_registering = self.state.data_agent_registering
                                    let obj = data_agent_registering.data[index]
                                    obj.hide_item = true
                                    self.setState({data_agent_registering: data_agent_registering})
                                }
                            } else if (tag === 'data_agent_search') {
                                util.log("ok data_agent_search")
                                let data_agent_search = self.state.data_agent_search
                                let obj = data_agent_search.data[index]
                                obj.status = status.toUpperCase()
                                self.setState({data_agent_search: data_agent_search})
                            }
                        } else {
                            target.disabled = false
                            swal("Ups!", payload.error.message, "warning")
                        }
                    } else {
                        target.disabled = false
                    }
                }
                target.classList.remove('m-loader', 'm-loader--light', 'm-loader--right')
            })
    }

    detil_user(user_id, user_url) {
        this.setState({show_profile: true, show_user_id: user_id, show_user_url: user_url, show_user_type: 'not-public'})
    }

    detil_public_user(user_id, user_url) {
        this.setState({show_profile: true, show_user_id: user_id, show_user_url: user_url, show_user_type: 'public'})
    }

    detil_downline(e, index, master_id, master_name, master_url) {
        let self = this
        util.log("detil_downline", index, master_id, master_name, master_url, e)
        let downline = this.state.data_downline.data
        let master = downline[index]
        master.downline_btn_disable = true
        let title = {title: "Downline " + master_name, show: true}
        let pos = index + 1
        let coll = util.list_add_after(downline, pos, title)
        
        const target = e.target
        target.disabled = true
        target.classList.add('m-loader', 'm-loader--light', 'm-loader--right')

        let body = {
            "session_id" : this.props.session
        }
        let url = master_url
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("detil_downline", err)
                } else {
                    util.log("detil_downline", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                payload.results.list.map(function(item,i) {
                                    pos = pos + 1
                                    item.show_border_left = true
                                    coll = util.list_add_after(coll, pos, item)
                                })
                                if (payload.results.next_page !== null) {
                                    let more_data = {url: payload.results.next_page, show: true}
                                    coll = util.list_add_after(coll, pos + 1, more_data)
                                }
                            }
                            util.log("detil_downline", coll)
                            self.setState({data_downline: {data: coll}})
                        }
                    }
                }
            })
    }

    on_search_btn_load_more (next) {
        util.log(next)
        if (next.url) {
            let url = next.url
            let body = {
                "session_id" : this.props.session
            }
            let self = this
            self.setState({search_load_more_flag_processing: true})
            request.post(url)
                .set("Content-Type", "application/json")
                .send(body)
                .end(function(err, res) {
                    if (err || !res.ok) {
                        util.log(err)
                    } else {
                        util.log(res);
                        if (res.statusCode == 200) {
                            let payload = res.body
                            util.log(payload)
                            if (payload.status == "OK") {
                                let data_list = self.state.data_agent_search.data
                                var joined = data_list.concat(payload.results.list)
                                data_list.data = joined
                                
                                let show_more = false
                                if (payload.results.next_page !== null) {
                                    data_list.next = payload.results.next_page
                                    show_more = true
                                }

                                util.log(data_list)
                                self.setState({data_agent_search: data_list, search_show_more_btn: show_more})
                            } else {
                                swal("Ups!", payload.error.message, "warning")
                            }
                        }
                    }
                    self.setState({search_load_more_flag_processing: false})
                })
        }
    }

    on_downline_btn_load_more (next) {
        util.log(next)
        if (next.url) {
            let url = next.url
            let body = {
                "session_id" : this.props.session
            }
            let self = this
            self.setState({downline_load_more_flag_processing: true})
            request.post(url)
                .set("Content-Type", "application/json")
                .send(body)
                .end(function(err, res) {
                    if (err || !res.ok) {
                        util.log(err)
                    } else {
                        util.log(res);
                        if (res.statusCode == 200) {
                            let payload = res.body
                            util.log(payload)
                            if (payload.status == "OK") {
                                let data_list = self.state.data_downline.data
                                var joined = data_list.concat(payload.results.list)
                                data_list.data = joined
                                
                                let show_more = false
                                if (payload.results.next_page !== null) {
                                    data_list.next = payload.results.next_page
                                    show_more = true
                                }

                                util.log(data_list)
                                self.setState({data_downline: data_list, downline_show_more_btn: show_more})
                            } else {
                                swal("Ups!", payload.error.message, "warning")
                            }
                        }
                    }
                    self.setState({downline_load_more_flag_processing: false})
                })
        }
    }

    on_detil_downline_btn_load_more(e, pos, next) {
        const self = this
        const target = e.target
        target.disabled = true
        target.classList.add('m-loader', 'm-loader--primary', 'm-loader--right')
        let body = {
            "session_id" : this.props.session
        }
        let url = next.url
        let data_downline = self.state.data_downline.data
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    swal('Error', err, 'error')
                } else {
                    util.log("more_detil_downline", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                let p = pos
                                payload.results.list.map(function(item,i) {
                                    p = p + 1
                                    item.show_border_left = true
                                    data_downline = util.list_add_after(data_downline, p, item)
                                })
                                if (payload.results.next_page !== null) {
                                    let more_data = {url: payload.results.next_page, show: true}
                                    data_downline = util.list_add_after(data_downline, p + 1, more_data)
                                }
                                let more_btn = data_downline[pos]
                                more_btn.show = false
                            }
                            self.setState({data_downline: {data: data_downline}})
                        }
                    }
                }
            })
    }

    detil_report_agent(agent_id, agent_name, master_id) {
        util.log(agent_id, agent_name, master_id)
        if (master_id.length === 0) {
            master_id = this.props.profile.masterid
        }
        this.setState({show_report_agent: true, show_report_agent_data: {agent_id: agent_id, agent_name: agent_name, master_id: master_id}})
    }

    riwayat_tx_agent(agent_id, agent_name, master_id) {

    }

    daftar_device(agent_id, agent_name, photo_url, master_id) {
        util.log(agent_id, agent_name, master_id)
        if (master_id.length === 0) {
            master_id = this.props.profile.masterid
        }
        let self = this
        this.setState({show_daftar_device: true, show_daftar_device_data: {agent_id: agent_id, agent_name: agent_name, master_id: master_id, photo_url: photo_url, close : ()=>{
                    self.setState({show_daftar_device: false})
                }}})
    }

    transfer_balance_agent(agent_type, agent_id, agent_name, photo_url, master_id) {
        if (master_id.length === 0) {
            master_id = this.props.profile.masterid
        }
        this.setState({show_transfer_balance: true, show_transfer_balance_data: {agent_id: agent_id, agent_name: agent_name, master_id: master_id, agent_type: agent_type, photo_url: photo_url}})
    }

    load_propinsi() {
        let self = this
        request.get(apis.list_propinsi).end((err, res) => {
            if (err) {
                util.log("error: " + err)
            } else {
                util.log(res);
                if (res.status == 200) {
                    const data = JSON.parse(res.text)
                    if (data.status == "OK") {
                        let list = data.results.list
                        let t = []
                        list.map(item =>
                            t.push({'province_id' : item.province_id, 'province_name' : item.province_name})
                        )
                        self.setState({list_propinsi: t})
                    }
                }
            }
        })
    }

    new_agent_btn_click(e) {
        this.props.history.push({
            pathname: '/master/create-agent',
            search: '',
            state: {}
        })
    }

    new_downline_btn_click(e) {
        this.props.history.push({
            pathname: '/master/create-downline',
            search: '',
            state: {}
        })
    }

    render() {
        let self = this
        const DownlineItemView = (props) => 
            <div id={'downline-' + props.data.item_id} className="m-widget4__item" style={props.data.show_border_left ? {borderLeft: '2px solid cadetblue',paddingLeft: '10px'} : {}}>
                <div className="m-widget4__img m-widget4__img--pic">
                    <img src={props.data.photo_filename !== null && props.data.photo_filename.length !== 0 ? props.data.photo_filename : photo_default} style={{height: 55+'px',width: 55+'px'}}/>
                </div>
                <div className="m-widget4__info">
                    <span className="m-widget4__title">
                        {props.data.fullname}
                    </span>
                    <br/>
                    <span className="m-widget4__sub">
                        {props.data.item_id} &nbsp; &bull; &nbsp; {props.data.status}
                    </span>
                </div>
                <div className="m-widget4__ext" style={{display: 'flex',marginTop: '15px'}}>

                    {props.data.status === 'REGISTERING' ? <React.Fragment>
                        <button id={'registering-master-approve-' + props.key} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" style={{marginRight: '5px'}} onClick={(e) => self.change_status_master_agent(e, props.pos, props.data.master_agent_id, label_btn[props.data.status], 'data_master_agent_registering')}>
                        {label_btn[props.data.status]}
                        </button>
                        <button id={'registering-master-reject-' + props.key} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" style={{marginRight: '5px'}} onClick={(e) => self.change_status_master_agent(e, props.pos, props.data.master_agent_id, 'UNAPPROVED', 'data_master_agent_registering')}>
                            Reject
                        </button>
                    </React.Fragment> : ''}

                    {props.data.status !== 'REGISTERING' ?
                    <button id={'status-master-' + props.key} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" style={{marginRight: '5px'}} onClick={(e) => self.change_status_master_agent(e, props.pos, props.data.master_agent_id, label_btn[props.data.status], 'data_master_agent_status')}>
                        {label_btn[props.data.status]}
                    </button>
                    : ''}

                    {props.data.next_downline && props.data.next_downline !== null ? <button disabled={props.data.downline_btn_disable ? true:false} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" onClick={(e) => self.detil_downline(e,props.pos, props.data.item_id, props.data.fullname, props.data.next_downline.url)} style={{marginRight: '5px'}}>
                        Downline
                    </button> : ''}

                    <div className="dropdown">
                        <button className="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{padding: '5px',borderRadius: '50%',marginLeft: '5px',height: '30px',width: '30px'}}>
                            <i className="la la-ellipsis-h" style={{fontSize: 'medium'}}></i>
                        </button>

                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', transform: 'translate3d(0px, 37px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>
                            <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.detil_report_agent("", props.data.fullname, props.data.master_agent_id)}>
                                Reporting
                            </a>
                            <a className="dropdown-item" style={{cursor:'pointer',display:'none'}} onClick={(e) => self.riwayat_tx_agent("", props.data.fullname, props.data.master_agent_id)}>
                                Riwayat Transaksi
                            </a>
                            <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.transfer_balance_agent('master', props.data.master_agent_id, props.data.fullname, props.data.photo_filename, '-1')}>
                                Transfer Balance
                            </a>
                            <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.detil_user(props.data.item_id, props.data.next_detail.url)}>
                                Profil
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        const DownlineLabelView = (props) => 
            <div className="m-widget4__item" style={props.data.show ? {width: '100%',borderLeft: '2px solid cadetblue',paddingLeft: '15px'} : {display: 'none'}}>
                {props.data.url ? 
                    <button type="button" style={{width: '-webkit-fill-available'}} onClick={(e) => this.on_detil_downline_btn_load_more(e, props.pos, props.data.url)} className='btn btn-secondary'>
                        More
                    </button>
                : 
                <div className="m-widget4__info" style={{padding:'0'}}>
                    <span className="m-widget4__title">{props.data.title}</span>
                </div>}
            </div>

        return (
            <div className="row">

                <div className="col-lg-6">
                    <div className="m-portlet">
                        <div className="m-portlet__head">
                            <div className="m-portlet__head-caption">
                                <div className="m-portlet__head-title">
                                    <h3 className="m-portlet__head-text">
                                        Daftar Agent
                                    </h3>
                                    <div style={{display:'table-cell',verticalAlign:'middle'}}>
                                        <button className="btn m-btn--pill btn-secondary m-btn m-btn--icon" style={{fontSize: 'smaller',padding:'.5rem 1em',margin:'0 10px'}} 
                                        onClick={(e) => self.new_agent_btn_click(e)}>
                                            <span><i className="la la-plus"></i><span>My Agent</span></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="m-portlet__head-tools">
                                <ul className="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist">
                                    <li className="nav-item m-tabs__item">
                                        <a className="nav-link m-tabs__link" data-toggle="tab" href="#m_widget4_tab1_content" role="tab">
                                            Cari
                                        </a>
                                    </li>
                                    <li className="nav-item m-tabs__item">
                                        <a className="nav-link m-tabs__link active" data-toggle="tab" href="#m_widget4_tab2_content" role="tab">
                                            Registering
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="m-portlet__body" style={{maxHeight: '1000px', minHeight: '600px',overflow: 'auto'}}>
                            <div className="tab-content">
                                <div className="tab-pane" id="m_widget4_tab1_content">
                                    <div className="m-widget4">
                                        <div className="form-group m-form__group" style={{marginBottom: '5px'}}>
                                            <label style={{fontWeight: 600}}>Cari Agent</label>
                                            <div style={{borderBottom: '1px dashed #ebedf2', paddingBottom: '10px'}}>
                                                <div className="row">
                                                    <label className="col-lg-2" style={{margin: 'auto', fontWeight: 600, textAlign: 'left'}}>
                                                        Key:
                                                    </label>
                                                    <div className="col-lg-10">
                                                        <input onChange={(e) => this.on_input_change(e)}
                                                            type="text"
                                                            className="form-control m-input"
                                                            name="search_agent_name"
                                                            value={this.state.search_agent_name}
                                                            placeholder="Nama / Nomor Telepon"
                                                        style={{marginBottom: '10px'}}/>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <label className="col-lg-2" style={{margin: 'auto', fontWeight: 600, textAlign: 'left'}}>
                                                        Provinsi:
                                                    </label>
                                                    <div className="col-lg-5">
                                                        <select className="form-control m-input" id="propinsi-sel" value={this.state.propinsi} onChange={(e) => this.on_select_change(e)} style={{marginBottom: '10px'}}>
                                                            <option key={999} value=""> -- Provinsi -- </option>
                                                            {
                                                                self.state.list_propinsi.length != 0 ? self.state.list_propinsi.map((item, i) =>
                                                                    <option key={i} value={item.province_name}>
                                                                        {item.province_name}
                                                                    </option>
                                                                ) : ''
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-5">
                                                        <select className="form-control m-input" id="kota-sel" value={this.state.kota} onChange={(e) => this.on_select_change(e)} style={{marginBottom: '10px'}}>
                                                            <option key={999} value=""> -- Kota -- </option>
                                                            {
                                                                self.state.list_kota.length != 0 ? self.state.list_kota.map((item, i) =>
                                                                    <option key={i} value={item.city_name}>
                                                                        {item.city_name}
                                                                    </option>
                                                                ) : ''
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                
                                                <div className="row">
                                                    <label className="col-lg-2" style={{margin: 'auto', fontWeight: 600, textAlign: 'left'}}>
                                                        Downline:
                                                    </label>
                                                    <div className="col-lg-10">
                                                        <select id="search_downline" name="search_downline" className="form-control m-input" value={this.state.search_agent_downline} onChange={(e) => this.on_select_change(e)} style={{marginBottom: '10px'}}>
                                                            <option key={999} value="">-- Agent Saya --</option>
                                                            {
                                                                self.state.data_downline.length != 0 ? self.state.data_downline.data.map((item, i) =>
                                                                    <option key={i} value={item.master_agent_id}>
                                                                        {item.fullname}
                                                                    </option>
                                                                ) : ''
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <label className="col-lg-2" style={{margin: 'auto', fontWeight: 600, textAlign: 'left'}}>
                                                        Status:
                                                    </label>
                                                    <div className="col-lg-10">
                                                        <select id="search_status" name="search_status" className="form-control m-input" value={this.state.search_agent_status} onChange={(e) => this.on_select_change(e)} style={{marginBottom: '10px'}}>
                                                            <option key={0} value="">All</option>
                                                            <option key={1} value="active">Active</option>
                                                            <option key={2} value="deactivated">Deactivated</option>
                                                            <option key={3} value="suspended">Suspended</option>
                                                            <option key={4} value="unapproved">Unapproved</option>
                                                            <option key={5} value="registering">Registering</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <button type="button" className={this.state.flag_cari_processing ? 'btn btn-primary btn-sm m-btn m-btn--custom m-loader m-loader--light m-loader--right' : 'btn btn-primary btn-sm m-btn m-btn--custom'}
                                                    onClick={this.search_agent} 
                                                    style={{marginBottom: '10px', marginTop: '10px'}}>
                                                    Submit
                                                </button>
                                            </div>
                                        </div>

                                        {this.state.data_agent_search.length !== 0 && this.state.data_agent_search.data !== undefined ?
                                            this.state.data_agent_search.data.map(function(item, key) {
                                                return (item.hide_item ? '' : <div key={key} className="m-widget4__item">
                                                    <div className="m-widget4__img m-widget4__img--pic">
                                                        <img src={item.photo_filename !== null && item.photo_filename.length !== 0 ? item.photo_filename : photo_default} style={{height: 55+'px',width: 55+'px'}}/>
                                                    </div>
                                                    <div className="m-widget4__info">
                                                        <span className="m-widget4__title">
                                                            {item.fullname}
                                                        </span>
                                                        <br/>
                                                        <span className="m-widget4__sub">
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                    <div className="m-widget4__ext" style={{display: 'flex',marginTop: '10px'}}>
                                                        <button id={'search-' + key} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" style={{marginRight: '5px'}} onClick={(e) => self.change_status_agent(e, key, self.state.search_agent_downline, item.agent_id, label_btn[item.status], 'data_agent_search')}>
                                                            {label_btn[item.status]}
                                                        </button>
                                                        <div className="dropdown">
                                                            <button className="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{padding: '5px',borderRadius: '50%',marginLeft: '5px',height: '30px',width: '30px'}}>
                                                                <i className="la la-ellipsis-h" style={{fontSize: 'medium'}}></i>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', transform: 'translate3d(0px, 37px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>

                                                                <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.detil_report_agent(item.agent_id, item.fullname, self.state.search_agent_downline)}>
                                                                    Reporting
                                                                </a>

                                                                <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.daftar_device(item.agent_id, item.fullname, item.photo_filename, self.state.search_agent_downline)}>
                                                                    Daftar Device
                                                                </a>

                                                                <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.transfer_balance_agent('agent', item.agent_id, item.fullname, item.photo_filename, self.state.search_agent_downline)}>
                                                                    Transfer Balance
                                                                </a>

                                                                <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.detil_user(item.item_id, item.next_detail.url)}>
                                                                    Profil
                                                                </a>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>)
                                        })
                                        : ''}
                                        {this.state.search_show_more_btn ? <button type="button" style={{width: '-webkit-fill-available', marginTop: '20px'}} onClick={(e) => this.on_search_btn_load_more(this.state.data_agent_search.next)} className={this.state.search_load_more_flag_processing ? 'btn btn-secondary m-loader m-loader--primary m-loader--right' : 'btn btn-secondary'}>
                                            Load More
                                        </button> : ''}
                                    </div>
                                </div>
                                <div className="tab-pane active" id="m_widget4_tab2_content">
                                    <div className="m-widget4">
                                        
                                        {this.state.data_agent_registering.length !== 0 && this.state.data_agent_registering.data !== undefined ?
                                            this.state.data_agent_registering.data.map(function(item, key) {
                                                return (item.hide_item ? '' : <div key={key} className="m-widget4__item">
                                                    <div className="m-widget4__img m-widget4__img--pic">
                                                        <img src={item.photo_filename !== null && item.photo_filename.length !== 0 ? item.photo_filename : photo_default} style={{height: 55+'px',width: 55+'px'}}/>
                                                    </div>
                                                    <div className="m-widget4__info">
                                                        <span className="m-widget4__title">
                                                            {item.fullname}
                                                        </span>
                                                        <br/>
                                                        <span className="m-widget4__sub">
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                    <div className="m-widget4__ext" style={{display: 'flex',marginTop: '10px'}}>
                                                        <button id={'registering-approve-' + key} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" style={{marginRight: '5px'}} onClick={(e) => self.change_status_agent(e, key, '', item.agent_id, label_btn[item.status], 'data_agent_registering')}>
                                                            {label_btn[item.status]}
                                                        </button>
                                                        <button id={'registering-reject-' + key} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" style={{marginRight: '5px'}} onClick={(e) => self.change_status_agent(e, key, '', item.agent_id, 'UNAPPROVED', 'data_agent_registering')}>
                                                            Reject
                                                        </button>
                                                        <button className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" onClick={(e) => self.detil_user(item.item_id, item.next_detail.url)}>
                                                            Profil
                                                        </button>
                                                    </div>
                                                </div>)
                                        })
                                        : <div style={{textAlign: 'center'}}>Tidak Ada Permintaan</div>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="m-portlet m-portlet--full-height ">
                        <div className="m-portlet__head">
                            <div className="m-portlet__head-caption">
                                <div className="m-portlet__head-title">
                                    <h3 className="m-portlet__head-text">
                                        Daftar Upline & Downline
                                    </h3>
                                    <div style={{display:'table-cell',verticalAlign:'middle'}}>
                                        <button className="btn m-btn--pill btn-secondary m-btn m-btn--icon" style={{fontSize:'smaller',padding:'.5rem 1em',margin:'0 10px'}} 
                                        onClick={(e) => self.new_downline_btn_click(e)}>
                                            <span><i className="la la-plus"></i><span>My Downline</span></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="m-portlet__body" style={{maxHeight: '100px', minHeight: '600px',overflow: 'auto'}}>
                            <div className="tab-content">
                                <div className="tab-pane active" id="m_widget4_tab1_content">
                                    <div className="m-widget4">
                                        <div style={{fontSize: '15px',fontWeight: '600'}}>Upline Anda</div>
                                        
                                        {this.state.data_upline.length !== 0 && this.state.data_upline.data !== undefined ?
                                            this.state.data_upline.data.map(function(item, key) {
                                                return (<div key={key} className="m-widget4__item">
                                                    <div className="m-widget4__img m-widget4__img--pic">
                                                        <img src={item.photo_filename !== null && item.photo_filename.length !== 0 ? item.photo_filename : photo_default} style={{height: 55+'px',width: 55+'px'}}/>
                                                    </div>
                                                    <div className="m-widget4__info">
                                                        <span className="m-widget4__title">
                                                            {item.fullname}
                                                        </span>
                                                        <br/>
                                                        <span className="m-widget4__sub">
                                                            {item.item_id}
                                                        </span>
                                                    </div>
                                                    <div className="m-widget4__ext">
                                                        <button className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" onClick={(e) => self.detil_public_user(item.item_id, item.url_profile)}>
                                                            Profil
                                                        </button>
                                                    </div>
                                                </div>)
                                        })
                                        : <div style={{}}>Tidak Ada</div>}

                                        <div style={{fontSize: '15px',fontWeight: '600', marginTop: '25px'}}>Downline Anda</div>
                                        
                                        {this.state.data_downline.length !== 0 && this.state.data_downline.data !== undefined ?
                                            this.state.data_downline.data.map(function(item, key) {
                                                return (item.item_id ? <DownlineItemView data={item} pos={key} key={key}/> : <DownlineLabelView data={item} pos={key} key={key}/>)
                                        })
                                        : <div style={{}}>Tidak Ada</div>}
                                        {this.state.downline_show_more_btn ? <button type="button" style={{width: '-webkit-fill-available', marginTop: '20px'}} onClick={(e) => this.on_downline_btn_load_more(this.state.data_downline.next)} className={this.state.downline_load_more_flag_processing ? 'btn btn-secondary m-loader m-loader--primary m-loader--right' : 'btn btn-secondary'}>
                                            Load More
                                        </button> : ''}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.show_profile ? <ModalProfile data={{user_id : this.state.show_user_id, url: this.state.show_user_url, type: this.state.show_user_type,  close : ()=>{
                    self.setState({show_profile: false})
                }}}/> : ''}
                {this.state.show_report_agent ? <ModalListCommisionBonus data={{agent_id : this.state.show_report_agent_data.agent_id, master_id: this.state.show_report_agent_data.master_id, agent_name: this.state.show_report_agent_data.agent_name, close : ()=>{
                    self.setState({show_report_agent: false})
                }}}/> : ''}
                {this.state.show_transfer_balance ? <ModalTransferBalance data={{agent_type : this.state.show_transfer_balance_data.agent_type, agent_id : this.state.show_transfer_balance_data.agent_id, master_id: this.state.show_transfer_balance_data.master_id, agent_name: this.state.show_transfer_balance_data.agent_name, photo_url : this.state.show_transfer_balance_data.photo_url, close : ()=>{
                    self.setState({show_transfer_balance: false})
                }}}/> : ''}
                {this.state.show_daftar_device ? <ModalDevice data={this.state.show_daftar_device_data} /> : ''}
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    update_current_page:  val => dispatch(do_action(action.ACTION_UPDATE_CURRENT_PAGE, val)),
    update_balance: val => dispatch(do_action(action.ACTION_UPDATE_USER_BALANCE, val))
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(MAgentManageAgent)



// WEBPACK FOOTER //
// ./src/component/magent_manage_agent.js